import { motion } from 'framer-motion';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import { DATA_ROOM_TABS } from '../constants/data-room-tabs.const';
import { dataRoomTabFromPathname } from '../utils/data-room-path.util';

export const DataRoomTabs: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const selectedTab = dataRoomTabFromPathname(pathname);

  return (
    <div className="flex w-full shrink-0 items-end gap-4 border-b border-gray-200 px-4 pt-6">
      {DATA_ROOM_TABS.map((tab) => {
        const isSelected = selectedTab === tab.id;

        return (
          <Button
            className={twMerge(
              'relative flex h-full w-fit rounded-none px-1 pb-4 text-sm font-[450] leading-5 text-gray-400 transition-colors duration-200 ease-out',
              isSelected && 'font-[550] text-brand-700',
            )}
            key={tab.id}
            onClick={() => navigate(tab.path)}
            styleType="NONE"
          >
            <AppFormattedMessage id={tab.title} />
            {/* One shared underline that slides to the selected tab instead of jumping. */}
            {isSelected && (
              <motion.span
                className="absolute inset-x-0 -bottom-px h-0.5 bg-brand-700"
                layoutId="data-room-tab-underline"
                transition={{ duration: 0.3, ease: 'easeOut' }}
              />
            )}
          </Button>
        );
      })}
    </div>
  );
};
